// extracted by mini-css-extract-plugin
module.exports = {"BasicImage":"ArticleImages_BasicImage__1nptN","Caption":"ArticleImages_Caption__39M-o","InterviewImages":"ArticleImages_InterviewImages__1G4nF"};